import { Link } from "react-router-dom";
import AdLeadForm from "@/components/AdLeadForm";

// Unlisted landing page for ad campaigns (Instagram, Facebook, etc.) — intentionally
// not linked from Header/nav or any other page, reachable only via the direct URL
// used in ad creatives. Deliberately no site navigation, so ad traffic stays focused
// on the single conversion action instead of wandering off to the rest of the site.
export default function AdPromoPage() {
  return (
    <main className="min-h-screen bg-[var(--bg)] flex flex-col">
      <header className="pt-10 pb-6 px-4 text-center">
        <Link to="/" className="inline-block">
          <span className="font-display text-2xl font-bold text-white">Eazy-<span className="text-[var(--gold)]">Travels</span></span>
        </Link>
      </header>

      <section className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-xl">
          <div className="text-center mb-8">
            <p className="overline mb-3">Free Personalized Plan</p>
            <h1 className="font-display text-3xl sm:text-4xl font-black text-white leading-tight mb-3">
              Tell us where you want to go
            </h1>
            <p className="text-white/65">
              Share a few details and our team will put together a plan made for you — no obligation.
            </p>
          </div>
          <div className="card-dark p-6 sm:p-8" data-testid="ad-promo-form-card">
            <AdLeadForm />
          </div>
        </div>
      </section>
    </main>
  );
}
